var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.65055 12.7875C10.4902 7.11349 19.5098 7.11349 24.3494 12.7875L25.7675 14.4531C26.0358 14.7683 26.0358 15.2317 25.7675 15.547L24.3496 17.2124C19.51 22.8893 10.4872 22.8896 5.65024 17.2122L4.23254 15.547C3.96415 15.2317 3.96415 14.7683 4.23254 14.4531L5.65055 12.7875ZM6.93485 13.8821C6.93481 13.8822 6.93488 13.8821 6.93485 13.8821C6.93471 13.8823 6.93458 13.8824 6.93445 13.8826L5.98311 15L6.93476 16.1178C11.0978 21.0042 18.8994 21.0045 23.0654 16.1176L24.0169 15L23.0655 13.8826C23.0655 13.8825 23.0656 13.8826 23.0655 13.8826C18.8997 8.9988 11.1009 8.99863 6.93485 13.8821Z",
    fill: "#1E1542"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 13.5938C14.2233 13.5938 13.5938 14.2233 13.5938 15C13.5938 15.7767 14.2233 16.4062 15 16.4062C15.7767 16.4062 16.4062 15.7767 16.4062 15C16.4062 14.2233 15.7767 13.5938 15 13.5938ZM11.9062 15C11.9062 13.2914 13.2914 11.9062 15 11.9062C16.7086 11.9062 18.0938 13.2914 18.0938 15C18.0938 16.7086 16.7086 18.0938 15 18.0938C13.2914 18.0938 11.9062 16.7086 11.9062 15Z",
    fill: "#1E1542"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowIcon);
export default __webpack_public_path__ + "static/media/showIcon.4d53f8d277c9d4902c60b4c0e4215ea1.svg";
export { ForwardRef as ReactComponent };